import React from 'react';
import { getFerryBookingTransactionIdFromStorage } from 'Services/Api/_HumanWritten/BookingService/BookingService';
import classNames from 'classnames';

interface BookingWizardStepContentProps {
	contentClass?: string;
	children?: React.ReactNode;
}

export const FerryBookingWizardStepContent = ({
	children,
	contentClass = 'booking-wizard-step-content',
}: BookingWizardStepContentProps) => {
	const className = [contentClass];

	if (getFerryBookingTransactionIdFromStorage() !== null) {
		className.push('booking-wizard__timer-active');
	}

	return <div className={classNames(className)}>{children}</div>;
};
